import FingerBreathFlow from "@/components/Exercises/Breathing/FingerBreathFlow";
import { Button } from "@/components/ui/button";
import MediaPlayer from "@/components/ui/media-player";
import { Overlay } from "@/components/ui/overlay";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import fingerBreathIntro from "@/assets/audios/Fingers-breathing-exercise-introduction.m4a";
import { ExerciseLayout } from "@/components/ui/exercise-layout";
import { useChildSessionStore } from "@/lib/stores/childSessionStore";

export const Route = createFileRoute(
  "/(content)/children/exercises/(shared)/finger-breathing/"
)({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: "Finger Breathing Exercise - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "breathing.fingerBreath.title",
    navbar: {
      showTitle: true,
    },
  }),
});
function RouteComponent() {
  const [showOverlay, setShowOverlay] = useState(false);
  const [isPausedAudio, setIsPausedAudio] = useState(false);
  const { selectedEmotionId, reset } = useChildSessionStore();
  const navigate = useNavigate();

  const startExercise = () => {
    setIsPausedAudio(true);
    setShowOverlay(true);
  };

  const handleComplete = () => {
    setShowOverlay(false);
    setIsPausedAudio(false);
    if (selectedEmotionId) {
      navigate({ to: "/children/session" });
    }
  };

  const handleExit = () => {
    setShowOverlay(false);
    setIsPausedAudio(false);
    if (selectedEmotionId) {
      reset();
      navigate({ to: "/children/exercises" });
    }
  };

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Button className="w-full" onClick={startExercise}>
          <FormattedMessage id="breathing.startExercise" />
        </Button>
      }
    >
      <p className="text-small">
        <FormattedMessage id="breathing.fingerBreath.intro" />
      </p>

      <MediaPlayer src={fingerBreathIntro} isPaused={isPausedAudio} />

      <Overlay show={showOverlay} onClose={handleExit}>
        <FingerBreathFlow onComplete={handleComplete} />
      </Overlay>
    </ExerciseLayout>
  );
}
